import React, { useState, useEffect, useCallback } from 'react';
import { Select, notification, Flex } from 'antd';
import axiosInstance from '../../../../utilities/axios';

const { Option } = Select;

const EntityBlock = ({ value, onChange }) => {
  const [entityType, setEntityType] = useState(value?.type === 'entity' ? value?.statement.entity_type : value?.type === 'not' ? value?.statement.statement.entity_type : null);
  const [entityId, setEntityId] = useState(value?.type === 'entity' ? value?.statement.entity_id : value?.type === 'not' ? value?.statement.statement.entity_id : null);
  const [isNotSelected, setIsNotSelected] = useState(value?.type === 'not' ? true : false);
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    if (entityType) {
      axiosInstance
        .get('/entities', {
          params: { type: entityType },
        })
        .then((response) => {
          setEntities(response.data);
        })
        .catch((error) => {
          notification.error({
            message: 'Error',
            description: error.message,
          });
        });
    }
  }, [entityType]);

  // for value change parse the value and set the state
  useEffect(() => {
    if (value) {
      const { type, statement } = value;
      if (type === 'entity') {
        if (entityType !== statement.entity_type) {
          setEntityType(statement.entity_type);
        }
        setEntityId(statement.entity_id || null);
      } else if (type === 'not') {
        setIsNotSelected(true);
        if (entityType !== statement.statement.entity_type) {
          setEntityType(statement.statement.entity_type);
        }
        setEntityId(statement.statement.entity_id || null);
      }
    }
  }, [value]);

  // for change of entityType, id or not selected, set the value using onChange
  const updateParentValue = useCallback(() => {
    const newValue = isNotSelected
      ? { type: 'not', statement: { type: 'entity', statement: { entity_type: entityType, entity_id: entityId } } }
      : { type: 'entity', statement: { entity_type: entityType, entity_id: entityId } };

    // Avoid triggering onChange if the value hasn't changed
    if (!value) {
      onChange(newValue);
    } else if (newValue.type === 'entity') {
      if (
        value.type !== 'entity' ||
        value.statement.entity_type !== newValue.statement.entity_type ||
        value.statement.entity_id !== newValue.statement.entity_id
      ) {
        onChange(newValue);
      }
    } else if (newValue.type === 'not') {
      if (
        value.type !== 'not' ||
        value.statement.statement.entity_type !== newValue.statement.statement.entity_type ||
        value.statement.statement.entity_id !== newValue.statement.statement.entity_id
      ) {
        onChange(newValue);
      }
    }
  }, [entityType, entityId, isNotSelected, onChange]);

  useEffect(() => {
    updateParentValue();
  }, [updateParentValue]);

  return (
    <Flex
      vertical={false}
      style={{ gap: 8, marginTop: 8 }}
    >
      <Select
        placeholder="Select entity type"
        onChange={(value) => {
          setEntityType(value);
          setEntityId(null);
        }}
        value={entityType}
      >
        <Option value="all">All</Option>
        <Option value="region">Region</Option>
        <Option value="system">System</Option>
        <Option value="province">Province</Option>
        <Option value="binaural">Binaural</Option>
        <Option value="family">Family</Option>
        <Option value="brand">Brand</Option>
        <Option value="line">Line</Option>
        <Option value="style">Style</Option>
        <Option value="tech_level">Tech Level</Option>
      </Select>
      <Select 
        defaultValue = "is"
        allowClear={false}
        options={[
          { value: 'is', label: 'is' },
          { value: 'is not', label: 'is not' },
        ]}
        value={isNotSelected ? 'is not' : 'is'}
        onChange={(value) => setIsNotSelected(value === 'is not')}
      />

      <Select placeholder="Select entity ID"
        onChange={setEntityId}
        value={entityId}
      >
        {entities.map((entity) => (
          <Option key={entity.id} value={entity.id}>
            {entity.entity}
          </Option>
        ))}
      </Select>
    </Flex>
  );
};

export default EntityBlock;

